// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2sS6a","error":"styles_error__3vnWK"};